import(/* webpackMode: "eager", webpackExports: ["StuffList"] */ "/home/youidan/workspace/yinziai-web-explore/apps/web/lib/components/stuffs.tsx");
